/* ------------------------------------------------------------------
// NOTE: JQueryを使えるようにする必要最低限のコードを記述している
--------------------------------------------------------------------- */
const $ = require("jquery");

// NOTE: jquery-uiをインストールする前に必ず先に記述する必要がある。
window.$ = $;
window.jQuery = $;

require("jquery-ui-dist/jquery-ui");

export default $;
export { $ as jQuery };
